<template>
  <div class="animated fadeIn cities-page">
    <b-card style="border: 0;-">
      <v-card-title class="font-weight-bold"
        >مدیریت شهرها و استان‌ها</v-card-title
      >
      <v-row class="mb-4">
        <v-col>
          <v-text-field
            v-model="filter"
            prepend-inner-icon="mdi-magnify"
            label="جستجو با نام استان"
            @input="
              currentPage = 1;
              panel = '';
            "
            single-line
            hide-details
            :append-icon="filter ? 'mdi-close' : ''"
            @click:append="
              filter = '';
              panel = '';
            "
            filled
            rounded
          ></v-text-field
        ></v-col>
        <v-col class="text-end">
          <v-btn
            class="bc-primary text-white btn-radius float-end"
            width="200"
            height="45"
            elevation="0"
            @click="
              openAddDialog('استان', '');
              newItem = {
                name: '',
                motto: '',
                description: '',
              };
            "
          >
            <v-icon class="me-1">mdi-plus-circle</v-icon>
            افزودن استان جدید
          </v-btn>
        </v-col>
      </v-row>
      <div
        v-if="busy"
        class="d-flex flex-column align-items-center text-center mt-8 py-6"
      >
        <v-progress-circular
          indeterminate
          color="#068D9D"
          class="align-middle button-td"
        ></v-progress-circular>
        <p class="primary--text font-weight-bold mt-5">
          در حال بارگذاری اطلاعات...
        </p>
      </div>
      <div v-else>
        <v-expansion-panels v-model="panel">
          <div v-if="!computedStates.length" class="my-8">
            <h5 class="primary--text">موردی برای نمایش وجود ندارد.</h5>
          </div>
          <v-expansion-panel
            v-for="(item, index) in computedStates"
            :key="index"
            v-else
            style="border: none !important; border-radius: 7px !important"
            @click="
              cityFilter = '';
              cityCurrentPage = 1;
            "
          >
            <div>
              <v-expansion-panel-header class="pe-6 ps-6 py-5 mb-0">
                <template v-slot:default="{ open }">
                  <div class="d-flex flex-column mx-0">
                    <div
                      class="d-flex flex-row justify-space-between"
                      :class="!open ? 'pb-4' : 'py-1'"
                    >
                      <div class="my-auto" style="width: 200px">
                        استان {{ item.name }}
                      </div>
                      <div class="my-auto" style="width: 200px">
                        {{ item.cities.length }} شهر
                      </div>
                      <div>
                        <v-btn
                          @click.stop="open = !open"
                          class="bc-green white--text py-5 btn-radius"
                          elevation="0"
                          @click="
                            openAddDialog('شهر', item);
                            newItem = { name: '' };
                          "
                          >افزودن شهر</v-btn
                        >
                        <v-btn
                          @click.stop="open = !open"
                          @click="openEditDialog('', item, 'استان')"
                          class="bc-yellow white--text py-5 btn-radius ms-2"
                          elevation="0"
                          width="80"
                          >ویرایش</v-btn
                        >
                        <v-btn
                          @click.stop="open = !open"
                          @click="openDeleteDialog(item, 'استان')"
                          class="bc-red white--text py-5 ms-2 btn-radius"
                          elevation="0"
                          width="80"
                          >حذف</v-btn
                        >
                      </div>
                    </div>
                    <v-row v-if="!open"
                      ><v-col class="text-center py-0"
                        ><v-icon color="grey"
                          >mdi-dots-horizontal</v-icon
                        ></v-col
                      ></v-row
                    >
                  </div>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content style="font-size: 15px">
                <v-divider></v-divider>
                <div v-if="item.cities.length" class="px-5">
                  <v-text-field
                    class="mt-4"
                    v-model="cityFilter"
                    prepend-inner-icon="mdi-magnify"
                    label="جستجو با نام شهر"
                    @input="cityCurrentPage = 1"
                    single-line
                    hide-details
                    :append-icon="cityFilter ? 'mdi-close' : ''"
                    @click:append="cityFilter = ''"
                    filled
                    rounded
                  ></v-text-field>
                  <div v-if="computedCities(item.cities).length">
                    <div
                      class="group-box"
                      v-for="(item2, index) in computedCities(item.cities)"
                      :key="index"
                    >
                      <div class="my-auto" style="width: 200px">
                        {{ item2.name }}
                      </div>

                      <div>
                        <v-btn
                          @click="openEditDialog(item, item2, 'شهر')"
                          class="bc-yellow white--text py-5 btn-radius ms-2"
                          elevation="0"
                          width="80"
                          >ویرایش</v-btn
                        >
                        <v-btn
                          @click="openDeleteDialog(item2, 'شهر')"
                          class="bc-red white--text py-5 ms-2 btn-radius"
                          elevation="0"
                          width="80"
                          >حذف</v-btn
                        >
                      </div>
                    </div>
                    <v-pagination
                      v-model="cityCurrentPage"
                      :length="
                        Math.ceil(
                          item.cities.filter((x) => x.name.includes(cityFilter))
                            .length / cityPerPage
                        )
                      "
                      :total-visible="5"
                      prev-icon="arrow_back"
                      next-icon="arrow_forward"
                    ></v-pagination>
                  </div>
                  <div class="group-box text-center" v-else>
                    <span class="mx-auto">شهر مورد نظر یافت نشد!</span>
                  </div>
                </div>
                <div v-else>
                  <div class="group-box text-center mx-5">
                    <span class="mx-auto"
                      >شهری برای این استان به ثبت نرسیده است.</span
                    >
                  </div>
                </div>
              </v-expansion-panel-content>
            </div>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-pagination
          v-model="currentPage"
          v-if="computedStates.length"
          :length="
            Math.ceil(
              states.filter((x) => x.name.includes(this.filter)).length /
                perPage
            )
          "
          :total-visible="5"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
          @input="panel = ''"
        ></v-pagination>
        <v-autocomplete
          v-if="computedStates.length"
          label="تعداد در هر صفحه:"
          style="width: 150px"
          v-model="perPage"
          :items="perPageOptions"
          item-text="text"
          item-value="value"
          @change="currentPage = 1"
        ></v-autocomplete>
      </div>
    </b-card>
    <v-dialog v-model="newDialog" :width="itemType == 'استان' ? '700' : '600'">
      <v-card class="modal-style pa-4">
        <span class="close-icon" @click="newDialog = false"
          ><v-icon class="red--text">mdi-close</v-icon></span
        >
        <v-card-title>
          <span>افزودن {{ itemType }} جدید</span>
        </v-card-title>
        <v-card-text class="py-6">
          <div>
            <label class="primary--text font-weight-bold ps-1"
              >نام {{ itemType }}:</label
            >
            <v-text-field
              outlined
              :placeholder="'نام ' + itemType"
              class="mt-2"
              v-model="newItem.name"
              hide-details
              dense
            ></v-text-field>
            <div class="my-4">
              <b
                class="red--text"
                v-if="itemType == 'شهر' && invalidCityName('newItem')"
              >
                <v-icon class="red--text">mdi-alert-circle-outline</v-icon>
                پیش از این، شهری با این نام برای استان انتخابی به ثبت رسیده است.
              </b>
              <b
                class="red--text"
                v-if="itemType == 'استان' && invalidStateName('newItem')"
              >
                <v-icon class="red--text">mdi-alert-circle-outline</v-icon>
                پیش از این، استانی با این نام به ثبت رسیده است.
              </b>
            </div>
            <div v-if="itemType == 'استان'">
              <div class="mt-8">
                <label class="primary--text font-weight-bold ps-1"
                  >شعار {{ itemType }}:</label
                >
                <v-textarea
                  outlined
                  :placeholder="'شعار ' + itemType"
                  class="mt-2"
                  v-model="newItem.motto"
                  dense
                  rows="1"
                  counter="30"
                  :rules="rules"
                ></v-textarea>
              </div>
              <div class="mt-8">
                <label class="primary--text font-weight-bold ps-1"
                  >شرح فعالیت‌های {{ itemType }}:</label
                >
                <vue-ckeditor v-model="newItem.description" :config="config" />
                <h6 v-if="checkLength('newItem')" class="red--text mt-2">
                  عبارت مورد نظر تنها می‌تواند 300 حرف داشته‌باشد.
                </h6>
              </div>
            </div>
          </div>
        </v-card-text>
        <div class="text-left">
          <v-btn
            class="bc-green btn-radius white--text py-5"
            elevation="0"
            :loading="loading"
            :disabled="computedDisabled"
            @click="addItem()"
            >افزودن {{ itemType }}</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDialog" :width="itemType == 'استان' ? '700' : '600'">
      <v-card class="modal-style pa-4">
        <span class="close-icon" @click="editDialog = false"
          ><v-icon class="red--text">mdi-close</v-icon></span
        >
        <v-card-title>
          <span>ویرایش {{ itemType }}</span>
        </v-card-title>
        <v-card-text class="py-6">
          <div>
            <label class="primary--text font-weight-bold ps-1"
              >نام استان:</label
            >
            <v-autocomplete
              v-if="itemType == 'شهر'"
              outlined
              placeholder="نام استان"
              class="mt-2"
              v-model="selected.stateId"
              :items="onlyStates"
              item-text="name"
              item-value="id"
              dense
            ></v-autocomplete>
            <v-text-field
              v-else
              outlined
              placeholder="نام استان"
              class="mt-2"
              v-model="selected.name"
              dense
            ></v-text-field>
          </div>
          <div v-if="itemType == 'شهر'">
            <label class="primary--text font-weight-bold ps-1">
              نام شهر:
            </label>
            <v-text-field
              outlined
              placeholder="نام شهر"
              class="mt-2"
              v-model="selected.cityName"
              dense
            ></v-text-field>
          </div>
          <div v-if="selected.name" class="mb-4">
            <b
              class="red--text"
              v-if="
                itemType == 'شهر' &&
                (selected.stateId == selected.beforeParentId
                  ? selected.cityName != selected.beforeName
                  : true) &&
                invalidCityName2('selected')
              "
            >
              <v-icon class="red--text">mdi-alert-circle-outline</v-icon>
              پیش از این، شهری با این نام برای استان انتخابی به ثبت رسیده است.
            </b>
            <b
              class="red--text"
              v-if="
                itemType == 'استان' &&
                selected.name != selected.beforeName &&
                invalidStateName('selected')
              "
            >
              <v-icon class="red--text">mdi-alert-circle-outline</v-icon>
              پیش از این، استانی با این نام به ثبت رسیده است.
            </b>
          </div>
          <div v-if="itemType == 'استان'">
            <div>
              <label class="primary--text font-weight-bold ps-1"
                >شعار {{ itemType }}:</label
              >
              <v-textarea
                outlined
                :placeholder="'شعار ' + itemType"
                class="mt-2"
                v-model="selected.motto"
                dense
                rows="1"
                counter="30"
                :rules="rules"
              ></v-textarea>
            </div>
            <div class="mt-8">
              <label class="primary--text font-weight-bold ps-1"
                >شرح فعالیت‌های {{ itemType }}:</label
              >
              <vue-ckeditor v-model="selected.description" :config="config" />
              <h6 v-if="checkLength('selected')" class="red--text mt-2">
                عبارت مورد نظر تنها می‌تواند 300 حرف داشته‌باشد.
              </h6>
            </div>
          </div>
        </v-card-text>
        <div class="text-left">
          <v-btn
            class="bc-green btn-radius py-5 white--text"
            elevation="0"
            :loading="loading"
            @click="editItem(selected.id)"
            :disabled="
              !selected.name ||
              (itemType == 'شهر'
                ? !selected.stateId ||
                  !selected.cityName ||
                  (selected.cityName != selected.beforeName &&
                    invalidCityName2('selected'))
                : false) ||
              (itemType == 'استان'
                ? selected.name != selected.beforeName &&
                  invalidStateName('selected')
                : false) ||
              computedDisabledForEdit
            "
            >ذخیره‌سازی تغییرات</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" width="600">
      <v-card class="modal-style pa-4">
        <span class="close-icon" @click="deleteDialog = false"
          ><v-icon class="red--text">mdi-close</v-icon></span
        >
        <v-card-title>
          <span
            >حذف {{ itemType }} <b>"{{ selected.name }}"</b></span
          >
        </v-card-title>
        <v-card-text class="py-6">
          <h4>
            <v-icon class="red--text">mdi-alert-circle-outline</v-icon>
            آیا از حذف {{ itemType }} فوق اطمینان دارید؟
          </h4>
        </v-card-text>
        <div class="text-left">
          <v-btn
            @click="deleteItem(selected.id)"
            :loading="loading"
            class="bc-green white--text btn-radius py-5"
            elevation="0"
            width="80"
            >بله</v-btn
          >
          <v-btn
            @click="deleteDialog = false"
            class="bc-red btn-radius white--text py-5 ms-2"
            elevation="0"
            width="80"
            >خیر</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueCkeditor from "vue-ckeditor2";
export default {
  components: {
    VueCkeditor,
  },
  data() {
    return {
      panel: null,
      states: [],
      filter: "",
      cityFilter: "",
      loading: false,
      busy: false,
      loaded: false,
      selected: {},
      newDialog: false,
      editDialog: false,
      deleteDialog: false,
      newItem: {
        name: "",
        motto: "",
        description: "",
      },
      currentPage: 1,
      perPage: 10,
      cityPerPage: 6,
      cityCurrentPage: 1,
      totalRows: "",
      perPageOptions: [
        { value: 10, text: "10" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
      itemType: "",
      parent: {},
      stateId: "",
      beforeParentId: "",
      beforeName: "",
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "Font",
          ],
        ],
      },
      rules: [
        (v) => {
          if (v)
            return (
              v.length <= 30 ||
              "عبارت مورد نظر تنها می‌تواند ۳۰ حرف داشته‌باشد."
            );
          else return true;
        },
      ],
      onlyStates: [],
      pageLoaded: false,
    };
  },
  computed: {
    computedStates() {
      let list = this.states.filter((x) => x.name.includes(this.filter));
      list = list.slice(
        this.perPage * (this.currentPage - 1),
        this.perPage * this.currentPage
      );
      return list;
    },
    computedDisabled() {
      if (this.newItem.name) {
        if (this.itemType == "استان") {
          if (
            this.checkLength("newItem") ||
            (this.newItem.motto && this.newItem.motto.length > 30)
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    computedDisabledForEdit() {
      if (this.itemType == "استان") {
        if (
          this.checkLength("selected") ||
          (this.selected.motto && this.selected.motto.length > 30)
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  methods: {
    openAddDialog(type, state) {
      this.itemType = type;
      if (this.itemType == "شهر") {
        this.parent = this.states.filter((x) => x.id == state.id)[0];
      }
      this.stateId = state.id;
      this.newDialog = true;
    },
    openEditDialog(parent, item, type) {
      this.itemType = type;
      if (this.itemType == "شهر") {
        this.parent = parent;
        this.$http
          .get(this.baseUrl + "/setad/admin/states/getCity/" + item.id, {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          })
          .then((res) => {
            if (res.status == 200) {
              this.selected = res.data;
              this.selected.beforeName = res.data.cityName;
              this.selected.beforeParentId = res.data.stateId;
              this.getStates();
              this.editDialog = true;
            } else {
              this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            }
          })
          .catch((err) => {
            this.toast("خطا: " + err.data, "error");
          });
      } else if (this.itemType == "استان") {
        this.selected = JSON.parse(JSON.stringify(item));
        this.selected.beforeName = JSON.parse(JSON.stringify(item.name));
        this.selected.beforeParentId = JSON.parse(JSON.stringify(item.id));
        this.editDialog = true;
      }
    },
    openDeleteDialog(item, type) {
      this.itemType = type;
      this.selected = item;
      this.deleteDialog = true;
    },
    computedCities(item) {
      let cities = item.filter((x) => x.name.includes(this.cityFilter));
      cities = cities.slice(
        this.cityPerPage * (this.cityCurrentPage - 1),
        this.cityPerPage * this.cityCurrentPage
      );
      return cities;
    },
    invalidCityName(data) {
      if (this.parent && this.parent.name) {
        let similarGroups = [];
        this.parent.cities.forEach((x) => {
          if (this[data].name == x.name) {
            similarGroups.push(x);
          }
        });
        if (similarGroups.length) {
          return true;
        } else return false;
      } else return false;
    },
    invalidCityName2(data) {
      if (this.states.length) {
        this.parent = this.states.filter(
          (x) => x.id == this.selected.stateId
        )[0];
        if (this.parent && this.parent.name) {
          let similarGroups = [];
          this.parent.cities.forEach((x) => {
            if (this[data].cityName == x.name) {
              similarGroups.push(x);
            }
          });
          if (similarGroups.length) {
            return true;
          } else return false;
        } else return false;
      }
    },
    invalidStateName(data) {
      if (this.states.length) {
        let similarGroups = [];
        this.states.forEach((x) => {
          if (this[data].name == x.name) {
            similarGroups.push(x);
          }
        });
        if (similarGroups.length) {
          return true;
        } else return false;
      } else return false;
    },
    getList() {
      this.busy = true;
      this.$http
        .get(this.baseUrl + "/setad/options/states/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.states = res.data;
            this.totalRows = this.states.length;
            this.busy = false;
            setTimeout(() => {
              this.loaded = true;
            }, 200);
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            this.busy = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.busy = false;
        });
    },
    getStates() {
      this.$http
        .get(this.baseUrl + "/setad/admin/states/getStates", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.onlyStates = res.data;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    addItem() {
      this.loading = true;
      if (this.itemType == "شهر") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/states/createCity",
            {
              name: this.newItem.name,
              stateId: this.stateId,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            if (res.status == 201) {
              this.toast(res.data.message, "success");
              this.loading = false;
              this.newDialog = false;
              this.getList();
            } else {
              this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
              this.loading = false;
            }
          })
          .catch((err) => {
            this.toast("خطا: " + err.response.data, "error");
            this.loading = false;
          });
      } else if (this.itemType == "استان") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/states/createState",
            {
              name: this.newItem.name,
              motto: this.newItem.motto,
              description: this.newItem.description,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            if (res.status == 201) {
              this.toast(res.data.message, "success");
              this.loading = false;
              this.newDialog = false;
              this.getList();
            } else {
              this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
              this.loading = false;
            }
          })
          .catch((err) => {
            this.toast("خطا: " + err.response.data, "error");
            this.loading = false;
          });
      }
    },
    editItem(id) {
      this.loading = true;
      if (this.itemType == "شهر") {
        this.$http
          .patch(
            this.baseUrl + "/setad/admin/states/editCity/" + id,
            {
              name: this.selected.cityName,
              stateId: this.selected.stateId,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            if (res.status == 200) {
              this.toast(res.data.message, "success");
              this.editDialog = false;
              this.loading = false;
              this.getList();
            } else {
              this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
              this.loading = false;
            }
          })
          .catch((err) => {
            this.toast("خطا: " + err.response.data, "error");
            this.loading = false;
          });
      } else {
        this.$http
          .patch(
            this.baseUrl + "/setad/admin/states/editState/" + id,
            {
              name:
                this.itemType == "شهر"
                  ? this.selected.cityName
                  : this.selected.name,
              stateId:
                this.itemType == "شهر" ? this.selected.stateId : undefined,
              motto: this.itemType == "استان" ? this.selected.motto : undefined,
              description:
                this.itemType == "استان"
                  ? this.selected.description
                  : undefined,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            if (res.status == 200) {
              this.toast(res.data.message, "success");
              this.editDialog = false;
              this.loading = false;
              this.getList();
            } else {
              this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
              this.loading = false;
            }
          })
          .catch((err) => {
            this.toast("خطا: " + err.response.data, "error");
            this.loading = false;
          });
      }
    },
    deleteItem(id) {
      this.loading = true;
      let type = this.itemType == "شهر" ? "city" : "state";
      this.$http
        .delete(this.baseUrl + "/setad/admin/states/delete" + type + "/" + id, {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.loading = false;
            this.deleteDialog = false;
            this.getList();
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            this.loading = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.loading = false;
        });
    },
    checkLength(variable) {
      if (this[variable].description) {
        if (this[variable].description.length) {
          let withoutSpace = this[variable].description.replaceAll(
            /<\/?[^>]+(>|$)/g,
            ""
          );
          withoutSpace = withoutSpace.replaceAll("&nbsp;", "");
          withoutSpace = withoutSpace.replaceAll(" ", "");
          let length = withoutSpace.length;
          if (length > 300) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss">
.cities-page {
  .v-expansion-panel,
  .v-expansion-panel-header {
    background-color: #f0f0f0 !important;
    color: #45495d !important;
    font-weight: bold;
    border-radius: 15px 6px 6px 15px !important;
    margin: 15px 0 !important;
    box-shadow: 0 !important;
    border: none !important;
  }

  .v-expansion-panel {
    border-right: 7px solid #4a826b !important;

    .v-pagination .v-pagination__item--active {
      background-color: #4a826b !important;
    }
    .v-pagination .v-pagination__item {
      font-weight: 400 !important;
    }
    button {
      outline: none !important;
    }
  }

  .v-expansion-panels .v-expansion-panel:not(:first-child):after {
    display: none;
  }

  .v-expansion-panel:before {
    box-shadow: none !important;
  }

  .v-expansion-panel-header__icon {
    display: none !important;
  }

  .group-box {
    background-color: #fff !important;
    color: #1f2846 !important;
    font-weight: bold;
    border-radius: 10px !important;
    margin-bottom: 15px;
    margin-top: 15px;
    padding: 25px;
    display: flex;
    justify-content: space-between;
    border: 1px solid #ccc;
    // box-shadow: 0 10px 5px -10px;
  }
}

.modal-style {
  border-radius: 10px !important;
  position: relative;
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 10px;
    margin: 0 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: #ececec;
    opacity: 0.5;
    border-radius: 1px !important;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #b9b9b9;
    width: 10px;
    border-radius: 1px !important;
  }

  .close-icon {
    position: absolute;
    top: 20px;
    left: 20px;
    cursor: pointer;
  }
  label {
    font-size: 0.95rem;
  }
}
</style>
